import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../U3204';
import { useU3204Context } from '../U3204Context';
import { u3204BuildMissionModelFooterDisplay } from '../utils/u3204BuildMissionModelFooterLabel';
import { U3204MissionModelNotConfiguredTag, U3204MissionModelTag } from './U3204MissionModelTag';

const U3204MissionModelFooter: React.FC = () => {
  const { t } = useTranslation(NS);
  const { activeConversationId, activeMission } = useU3204Context();

  const display = useMemo(() => {
    if (!activeMission) return null;
    return u3204BuildMissionModelFooterDisplay({
      defaultProvider: activeMission.defaultProvider,
      defaultModel: activeMission.defaultModel,
      notConfiguredLabel: t('missionModelNotConfigured', { ns: NS }),
    });
  }, [activeMission, t]);

  if (!activeConversationId || !display) {
    return null;
  }

  if (display.kind === 'notConfigured') {
    return <U3204MissionModelNotConfiguredTag label={display.label} />;
  }

  return (
    <div
      className="flex min-w-0 flex-wrap items-center gap-1.5"
      role="list"
      aria-label={t('missionModelFooterAria', { ns: NS })}
    >
      {display.tags.map((tag) => (
        <span key={tag.kind} role="listitem">
          <U3204MissionModelTag tag={tag} />
        </span>
      ))}
    </div>
  );
};

export default U3204MissionModelFooter;
